import Button from "@app/sharedComponents/Button/Button"
import { ThemedText, ThemedView } from "@app/theme"
import { Image } from "react-native"

const HowItWorks = ({closeBottomSheet})=>{
    return(
        <ThemedView backgroundColor="bg-surface-primary" p="lg" >
            <ThemedText variant="h4s" color="text-primary" mb="2xl">Unlock more limit in just 3 steps</ThemedText>
            <ThemedView flexDirection="row" alignItems="center" >
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png" }} style={{ width: 40, height: 40 }} />
                </ThemedView>
                <ThemedView ml="sm" flex={1} flexWrap="wrap">
                    <ThemedText mb="xs">Check eligible credit limit</ThemedText>
                    <ThemedText>
                    Get you offer basis your holdings in 15s and accept your offer! 
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView flexDirection="row" alignItems="center" my="2xl">
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png" }} style={{ width: 40, height: 40 }} />
                </ThemedView>
                <ThemedView ml="sm" flex={1} flexWrap="wrap">
                    <ThemedText mb="xs">Check eligible credit limit</ThemedText>
                    <ThemedText>
                    Get you offer basis your holdings in 15s and accept your offer! 
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView flexDirection="row" alignItems="center" mb="2xl">
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png" }} style={{ width: 40, height: 40 }} />
                </ThemedView>
                <ThemedView ml="sm" flex={1} flexWrap="wrap">
                    <ThemedText mb="xs">Check eligible credit limit</ThemedText>
                    <ThemedText>
                    Get you offer basis your holdings in 15s and accept your offer! 
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <Button label="Ok, got it!" handlePress={closeBottomSheet} />
    </ThemedView>
    )
}

export default HowItWorks